import styled from "styled-components";

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const MainContentArea = styled.div`
  flex: 1;
  overflow-x: hidden;
  min-width: 400px;

  /* Only apply responsive design for extreme zoom IN scenarios */
  @media (max-width: 900px) {
    min-width: 350px;
  }
`;

export const SideMenuMainDiv = styled.div`
  width: 6vw;
  min-width: 60px;
  max-width: 80px;
  height: 92vh;
  background-color: #f9f5ff;
  flex-shrink: 0;
  /* gordon-glitch-help-button-covers-capture-rail-item-1024w: the rail's
     items are a fixed pixel height each, so on a short viewport their total
     content height can exceed 92vh. Previously the overflow was simply
     clipped by MainDiv's overflow-y:hidden with no way to reach the clipped
     item(s) — scroll instead so every rail item stays reachable (the
     Capture rail item can otherwise sit below the fold with no way in). */
  overflow-y: auto;
  overflow-x: hidden;

  /* Only apply responsive adjustments for extreme zoom IN scenarios */
  @media (max-width: 900px) {
    width: 60px;
  }
`;

export const MenuContainer = styled.div`
  width: 100%;
  background-color: ${(props) => props.backgroundColor || "white"};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 1;
  padding: 8px 4px;
  min-height: 80px;
`;

export const MenuInnerContainer = styled.div`
  width: ${(props) => props.width || "48px"};
  height: ${(props) => props.height || "68px"};
`;

export const MenuIconWrapper = styled.div`
  width: ${(props) => props.width || "48px"};
  height: ${(props) => props.height || "48px"};
  margin: ${(props) => props.margin || "0px"};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
`;

export const MenuTextWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MenuText = styled.p`
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: #123051;
  padding: ${(props) => props.padding || "0px"};
  margin: 0;
  line-height: 1.2;
`;
